import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=bdefae5c&scoped=true&"
import script from "./LoginAdmin.vue?vue&type=script&lang=js&"
export * from "./LoginAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LoginAdmin.vue?vue&type=style&index=0&id=bdefae5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdefae5c",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QInput,QIcon,QCardActions,QBtn});
